import { RoomAcl } from '@era/locations-sdk';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

// Will contain the ACL's connected to a room including
// all the inherited ACL's.
export type RoomAclState = EntityState<RoomAcl>;

export function selectRoomIdFromRoom(roomAcl: RoomAcl) {
  return roomAcl.resourceId;
}

export const adapter: EntityAdapter<RoomAcl> = createEntityAdapter<RoomAcl>({
  selectId: selectRoomIdFromRoom,
});

export const initialState: RoomAclState = adapter.getInitialState();
